import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { PerformancePeriodDTO } from '../types';
import { dateToISO8601 } from '../helpers/dates';
import { QueryFeature } from '../../../config/queryClient';

interface PortfolioSummaryDTO {
  marketValue: number | null;
}

interface FetchPortfolioSummaryParams {
  clientId: string;
  period?: PerformancePeriodDTO;
  startDate?: string;
  endDate?: string;
  accountId: string;
  groupId: string;
}

const fetchPortfolioSummary = async ({
  clientId,
  period,
  startDate,
  endDate,
  accountId,
  groupId,
}: FetchPortfolioSummaryParams): Promise<PortfolioSummaryDTO> =>
  authFetch(
    urlWithParams(
      '/Consumer/OrionAccountsWidgets/PortfolioSummary',
      {
        clientId,
        period,
        startDate,
        endDate,
        accountId: accountId || null,
        groupId: groupId || null,
        localDate: dateToISO8601(),
      },
      { skipNulls: true },
    ),
  );

export const PORTFOLIO_SUMMARY_QUERY_KEY = 'portfolioSummary';

interface UsePortfolioSummaryQueryParams {
  clientId: string;
  period?: PerformancePeriodDTO;
  startDate: string;
  endDate: string;
  accountId: string;
  groupId: string;
}

export const usePortfolioSummaryQuery = ({
  clientId,
  period,
  startDate: _startDate,
  endDate: _endDate,
  accountId,
  groupId,
}: UsePortfolioSummaryQueryParams) => {
  const startDate = period === undefined ? _startDate : undefined;
  const endDate = period === undefined ? _endDate : undefined;

  return useQuery(
    [
      QueryFeature.AccountPerformanceReporting,
      PORTFOLIO_SUMMARY_QUERY_KEY,
      clientId,
      period,
      startDate,
      endDate,
      accountId,
      groupId,
    ],

    () => fetchPortfolioSummary({ clientId, period, startDate, endDate, accountId, groupId }),

    {
      ...(period === undefined ? { cacheTime: 0 } : {}), // Do not cache custom ranges
    },
  );
};
